import { useStaticQuery, graphql } from "gatsby"

export const useNePasManquer = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allNodePage(
          filter: { field_mise_en_avant: { eq: true } }
          sort: { fields: field_ordre, order: DESC }
        ) {
          ...AllNePasManquer
        }
        taxonomyTermZoneDefinie(name: { eq: "a_ne_pas_manquer" }) {
          ...AllNePasManquerTaxo
        }
      }
    `
  )
  return data
}

export const queryNePasManquer = graphql`
  fragment AllNePasManquer on node__pageConnection {
    edges {
      node {
        drupal_internal__nid
        title
        drupal_id
        path {
          alias
        }
        field_affichage_planifie
        field_date_de_depublication(formatString: "DD/MM/YYYY", locale: "fr")
        field_date_de_publication(formatString: "DD/MM/YYYY", locale: "fr")
        relationships {
          field_taxonomie_thematique {
            name
          }
          field_image_page_de_base {
            localFile {
              extension
              SlugifiedPublicUrl
            }
          }
        }
      }
    }
  }
`

export const queryTaxo = graphql`
  fragment AllNePasManquerTaxo on taxonomy_term__zone_definie {
    drupal_internal__tid
    field_label
    description {
      processed
    }
  }
`
